import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { PickList } from 'primereact/picklist';
import { ListBox } from 'primereact/listbox';
import servicioObjetos from '../servicio/ServicioObjetos';
import { Dropdown } from 'primereact/dropdown';
import servicioFormatos from '../servicio/ServicioFormatos';

const TITULO_CREAR_USUARIO = "Alta de Usuario";
const TITULO_EDITAR_USUARIO = "Edición de Usuario";
export default class UsuarioCliente extends Component {

  constructor() {
    super();
    this.state = {
      editarUsuario:false,
      usuario: {},
      verModalUsuario: false,
      mostrarModalConfirmacion: false,
      errores: {},
      empresasDisponibles: [],
      empresasAsignadas: [],
      estado: [
        { label: "Activo", value: 1 },
        { label: "Inactivo", value: 0 }],
      paginacion: {
        registrosPorPagina: 100
      },
      paginacionPerfil: {
        registrosPorPagina: 100,
        join: { "ttUsuarios": "alias_ttUsuarios" },
        restriccionesDinamicas: [
        ]
      },
      perfilesDisponibles: [],
      perfilesAsignados: [],
      tituloModalUsuario: null,
      mostrarModalDetalleUsuario: false,
      detalleUsuario: null
    };
  }

  componentDidMount() {
    this.obtenerUsuarios();
  }

  asignarPerfiles = (event) => {
    this.setState({
      perfilesDisponibles: event.source,
      perfilesAsignados: event.target
    });
  }

  onChangeEmpresa = (event) => {
    this.setState({
      empresasDisponibles: event.source,
      empresasAsignadas: event.target
    });
  }

  resetFormulario = () => {
    this.setState({ verModalUsuario: false });
    this.setState({
      usuario: {},
      mostrarModalConfirmacion: false,
      errores: {},
    });
  };

  eliminarUsuario = () => {
    const { usuario } = this.state;
    servicioHttp
      .consumirPostHttp("usuario/eliminar.json", usuario)
      .then((response) => {
        this.setState({
          usuario: {},

          mostrarModalConfirmacion: false,
        });
        this.obtenerUsuarios();
      })
      .catch((error) => console.error(error));
  };

  mostrarModalUsuario = () => {
    this.obtenerPerfiles().then(response => {
      this.obtenerEmpresas().then(responseEmpresas => {
        this.setState({
          editarUsuario:false,
          verModalUsuario: true,
          perfilesDisponibles: response,
          empresasDisponibles: responseEmpresas,
          perfilesAsignados: [],
          empresasAsignadas: [],
          tituloModalUsuario: TITULO_CREAR_USUARIO
        });
      }).catch(error => {
        console.log("Error al consultar las empresas: ", error);
      });
    }).catch(error => {
      console.log("error: ", error);
    });
  };

  obtenerPagina() {
    servicioHttp
      .consumirPostHttp("usuario/consultar.json")
      .then((response) => {
        this.setState({ paginacion: response.data.objeto });
      })
      .catch((error) => {
        return this.growl.show({
          severity: "error",
          summary: "",
          detail:
            "Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde",
        });
      });
  }

  obtenerUsuarios = () => {
    let { paginacion } = this.state;
    servicioHttp.consumirPostHttp("usuario/consultar.json", paginacion).then((response) => {
      this.setState({ paginacion: response.data.objeto });
    }).catch((error) => console.error(error));
  };

  carTemplate = (car) => {
    return (
      <div className="p-clearfix">
        <div style={{ fontSize: '14px', float: 'center', margin: '15px 5px 0 0' }}>{car.nombre}</div>
      </div>
    );
  }

  carEmpresa = (car) => {
    console.log("car: ",car);
    return (
      <div className="p-clearfix">
  <div style={{ fontSize: '14px', float: 'center', margin: '15px 5px 0 0' }}>{car.registroPatronal} - {car.nombreCortoRazonSocial}</div>
      </div>
    );
  }

  obtenerPerfiles = () => {
    let { paginacionPerfil } = this.state;
    let elGrowl = this.growl;
    return new Promise(function (resolve, reject) {
      servicioHttp.consumirPostHttp('perfil/consultar.json', paginacionPerfil).then((response) => {
        if (servicioObjetos.esObjetoVacio(response.data.objeto.datos)) {
          elGrowl.show({ severity: 'warn', summary: 'Sin registros', detail: 'No cuenta con perfiles registrados' });
          reject(null);
        } else {
          resolve(response.data.objeto.datos);
        }
      }).catch((error) => reject(error));
    });
  };

  obtenerEmpresas = () => {
    let elGrowl = this.growl;
    return new Promise(function (resolve, reject) {
      servicioHttp.consumirPostHttp("empresa/obtener_empresas_usuarios.json").then((response) => {
        if (servicioObjetos.esObjetoVacio(response.data.lista)) {
          elGrowl.show({ severity: 'warn', summary: 'Sin registros', detail: 'No cuenta con empresas registradas' });
          reject(null);
        } else {
          resolve(response.data.lista);
        }
      }).catch((error) => reject(error));
    });
  }

  mostrarModalEliminar = (objeto) => {
    this.setState({ mostrarModalConfirmacion: true, usuario: objeto });
  };

  guardarUsuario = () => {
    const { usuario, perfil, perfilesAsignados, empresasAsignadas } = this.state;

    let validForm = this.validarFormulario(usuario, perfil, perfilesAsignados, empresasAsignadas);
    this.setState({ errores: validForm });
    if (!Object.keys(validForm).length) {
      let estado = usuario.estado;
      delete usuario['estado'];
      usuario.estado = estado;
      const jsonusuario = {
        tcPerfils: perfilesAsignados,
        tcEmpresas: empresasAsignadas,
        id: usuario.id,
        nombre: usuario.nombre,
        correo: usuario.correo,
        usuario: usuario.usuario,
        estado: usuario.estado,
        contrasena: usuario.contrasena,
        apellidoPaterno: usuario.apellidoPaterno,
        apellidoMaterno: usuario.apellidoMaterno,
      };

      servicioHttp
        .consumirPostHttp("usuario/guardar.json", jsonusuario)
        .then((response) => {
          this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.mensaje });
          this.obtenerUsuarios();
          this.setState({
            usuario: {},
            mostrarModalConfirmacion: false,
            target: []
          });
          this.obtenerUsuarios();
          this.setState({ verModalUsuario: false });
        })
        .catch((e) => {
          this.growl.show({ severity: 'warning', summary: 'Error!', detail: "No se guardo el usuario" });
          console.error(e);
        });
    }
  };

  validarFormulario = (valor, perfil, perfiles, empresas) => {
    const error = {};
    const{editarUsuario} =this.state;
    if (servicioObjetos.esObjetoVacio(valor.usuario))
      error.usuario = "El usuario es requerido";
  
    if (servicioObjetos.esObjetoVacio(valor.nombre))
      error.nombre = "El nombre es requerido";
    if (servicioObjetos.esObjetoVacio(valor.apellidoPaterno))
      error.apellidoPaterno = "El apellido paterno es requerido";
    if (servicioObjetos.esObjetoVacio(valor.correo))
      error.correo = "el correo es requerido";

      if(editarUsuario===false){ 
    if (valor.contrasena && Object.keys(valor.contrasena).length < 8) {
      error.contrasena =
        "La contraseña debe tener al minimo 8 caracteres y maximo 15 al menos un caracter, una mayuscula, una miniscula, un numero";
    }
    if (servicioObjetos.esObjetoVacio(valor.contrasena))
    error.contrasena = "La contraseña es requerida";
  }
    if (perfiles.length === 0)
      error.listaPerfiles = "Debe de seleccionar un perfil";
    if (empresas.length === 0)
      error.listaEmpresas = "Debe de seleccionar una empresa";
    if (servicioObjetos.esObjetoVacio(valor.estado))
      error.estado = "El campo es requerido";

    return error;
  };

  llenardatos = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
  };

  preeditar = (objeto) => {
    this.obtenerPerfiles().then(responsePerfiles => {
      this.setState({editarUsuario:true});
      servicioHttp.consumirPostHttp("usuario/listaperfiles.json", { id: objeto.id }).then((responsePerfilAsginado) => {
        servicioHttp.consumirPostHttp("empresa/obtener_empresas_usuario.json", { id: objeto.id }).then((responseEmpresaAsignada) => {
          this.obtenerEmpresas().then(responseEmpresasTotales => {
            // let { estado } = this.state;
            // let estado_usuario = estado.filter(obj => {
            //   return obj.value === objeto.estado;
            // });
            var usuarioEditar = JSON.parse(JSON.stringify(objeto));
            //let esta = estado_usuario[0];
            //delete usuarioEditar['estado'];
            //usuarioEditar.estado = esta;

            let perfilesDisponibles = responsePerfiles;
            let perfilesAsignados = responsePerfilAsginado.data;
            for (let index = 0; index < perfilesAsignados.length; index++) {
              let elementoBuscar = perfilesDisponibles.find(permiso => permiso.id === perfilesAsignados[index].id);
              if (undefined !== elementoBuscar) {
                servicioAsignacionValoresObjetos.eliminarObjetoMapa(perfilesDisponibles, elementoBuscar);
              }
            }

            let empresasDisponibles = responseEmpresasTotales;
            let empresasAsignadas = responseEmpresaAsignada.data.lista;
            this.setState({
              perfilesDisponibles: perfilesDisponibles,
              perfilesAsignados: perfilesAsignados,
              empresasAsignadas: empresasAsignadas,
              empresasDisponibles: empresasDisponibles,
              verModalUsuario: true,
              usuario: usuarioEditar,
              tituloModalUsuario: TITULO_EDITAR_USUARIO
            });
          }).catch(error => {
            console.log(error);
          })
        }).catch((e) => {
          console.error(e);
        });
      }).catch((e) => {
        console.error(e);
      });
    }).catch(error => {
      console.log(error);
    });
  }

  plantillaEstado(rowData, column) {    
    if (column.rowData.estado === 0)
      return <p style={{ backgroundColor: '#f008' , borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;
    if (column.rowData.estado === 1)
      return <p style={{backgroundColor: '#ff9f00', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
  }

  columnaFechaActualizacion = (rowData, column) => {
    return <div>{servicioFormatos.formatearFecha(rowData.fechaActualizacion)}</div>;
  }

  columnaFechaCambioContraseña = (rowData, column) => {
    return <div>{servicioFormatos.formatearFecha(rowData.fechaCambioContrasena)}</div>;
  }

  plantillaOpciones = (rowData, column) => {
    return (
      <div className="p-grid">
        <div className="p-col-12 p-md-12">
          <Button type="button" icon="pi-md-visibility" onClick={() => this.mostrarDetalleUsuario(rowData)} name="ver" tooltip="Ver detalle de usuario" ></Button>
          <Button type="button" icon="pi-md-edit" onClick={() => this.preeditar(rowData)} className="p-button-warning" name="editar" tooltip="Editar usuario" ></Button>
          <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(rowData)} className="p-button-danger" name="eliminar" tooltip="Eliminar usuario" ></Button>
        </div>
      </div>
    );
  }

  mostrarDetalleUsuario = (objeto) => {
    servicioHttp.consumirPostHttp('/usuario/detalle.json', { id: objeto.id }).then(response => {
      this.setState({
        mostrarModalDetalleUsuario: true,
        detalleUsuario: response.data.objeto
      });
    }).catch(error => {

    });

  }

  ocultarDetalleUsuario = () => {
    this.setState({
      mostrarModalDetalleUsuario: false,
      detalleUsuario: null
    });
  }


  empresaTemplate = (option) =>{
    return (
        <div className="p-clearfix">
            <span style={{fontSize:'1em',float:'right',margin:'1em .5em 0 0'}}><strong>{option.registroPatronal} </strong>  - {option.nombreCortoRazonSocial}</span>
        </div>
    );
}

seleccionDeLasEmpresas = (value) => {
  this.setState({empresasAsignadas: value});
}

  render() {
    const { editarUsuario, usuario, paginacion, errores, estado, verModalUsuario, perfilesDisponibles, perfilesAsignados, tituloModalUsuario,
      mostrarModalDetalleUsuario, detalleUsuario } = this.state;

    const pieDialogo = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button
          label="Crear"
          icon="pi-md-check"
          onClick={this.guardarUsuario}
        />
        <Button
          label="Cancelar"
          icon="pi-md-close"
          onClick={this.resetFormulario}
          className="p-button-danger "
        />
      </div>
    );

    // boton de confirmacion
    const dialogFooterConfirmacionEliminar = (
      <div>
        <Button
          icon="pi-md-check"
          onClick={this.eliminarUsuario}
          label="Si estoy seguro"
          className="p-button flat-btn"
        />
        <Button
          icon="pi-md-close"
          onClick={() =>
            this.setState({
              trabajador: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
          label="No estoy seguro"
          className="p-button-danger flat-btn"
        />
      </div>
    );

    const dialogFooterDetalleUsuario = (
      <div>
        <Button icon="pi-md-check" onClick={this.ocultarDetalleUsuario} label="Aceptar" className="p-button flat-btn" />        
      </div>
    );

    return (
      <div className="p-grid">
        <Growl ref={(el) => (this.growl = el)} />
        <div className="p-col-12">
          <div className="card card-w-title">
            <h1>Mis usuarios</h1>
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-4">
                <Button className="p-button-Primary p-button-raised" label="Agregar usuario" icon="pi-md-plus" tooltip={"Agregar usuario"} onClick={this.mostrarModalUsuario} />
              </div>
            </div>
          </div>
        </div>

        <Dialog visible={verModalUsuario} style={{ width: "60%" }} header={tituloModalUsuario}
         modal={true} footer={pieDialogo} onHide={this.resetFormulario}>
          <div className="p-grid form-group">
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="usuario" name="usuario.usuario" className={errores.usuario ? "p-error" : ""} value={usuario.usuario || ""} onChange={this.llenardatos} />
                <label>*Usuario:</label>
                {errores.usuario ? (
                  <div>
                    <br /> <Message severity="error" text={errores.usuario} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="nombre" name="usuario.nombre" value={usuario.nombre || ""} className={errores.nombre ? "p-error" : ""} onChange={this.llenardatos} />
                <label>*Nombre:</label>
                {errores.nombre ? (
                  <div>
                    <br /> <Message severity="error" text={errores.nombre} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="apellidoPaterno" name="usuario.apellidoPaterno" value={usuario.apellidoPaterno || ""} className={errores.apellidoPaterno ? "p-error" : ""} onChange={this.llenardatos} />
                <label>*Apellido Paterno:</label>
                {errores.apellidoPaterno ? (
                  <div>
                    <br /> <Message severity="error" text={errores.apellidoPaterno} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="apellidoMaterno" name="usuario.apellidoMaterno" value={usuario.apellidoMaterno || ""} className={errores.apellidoMaterno ? "p-error" : ""} onChange={this.llenardatos} />
                <label>Apellido Materno:</label>
                {errores.apellidoMaterno ? (
                  <div>
                    <br /> <Message severity="error" text={errores.apellidoMaterno} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="correo" name="usuario.correo" type="email" className={errores.correo ? "p-error" : ""} value={usuario.correo || ""} onChange={this.llenardatos} />
                <label>*Correo:</label>
                {errores.correo ? (
                  <div>
                    <br /> <Message severity="error" text={errores.correo} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            {editarUsuario === false ?
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText id="contrasena" name="usuario.contrasena" type="password" minLength="8" maxLength="15" className={errores.contrasena ? "p-error" : ""} value={usuario.contrasena || ""} onChange={this.llenardatos} />
                <label>*Contraseña:</label>
                {errores.contrasena ? (
                  <div>
                    <br />{" "}
                    <Message severity="error" text={errores.contrasena} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            :null}
            <div className="p-col-12 p-lg-6">
              <Dropdown id="estado" name="usuario.estado" 
              placeholder="*Estatus" optionLabel="label" optionValue="value" options={estado} 
              value={usuario.estado} 
              onChange={(e) => { this.llenardatos(e) }} autoWidth={false} style={{ width: "90%" }} />
              {errores.estado ? <div><Message severity="error" text={errores.estado} /></div> : null}
            </div>

            <div className="p-col-12 p-lg-12">
              <PickList source={perfilesDisponibles}
                showSourceControls={false}
                showTargetControls={false}
                target={perfilesAsignados}
                itemTemplate={this.carTemplate}
                sourceHeader="Perfiles disponibles"
                targetHeader="Perfiles asignados"
                responsive={true}
                sourceStyle={{ height: '300px' }}
                targetStyle={{ height: '300px' }}
                onChange={this.asignarPerfiles}></PickList>
              {errores.listaPerfiles ? (
                <Message severity="error" text={errores.listaPerfiles} />
              ) : null}

            </div>
            <h1>Selecciona las empresas para el usuario:</h1>
            <div className="p-col-10 p-lg-10">
            <ListBox value={this.state.empresasAsignadas} 
                filter={true} filterPlaceholder="Filtrar por RP o Nombre Corto"
                filterBy="registroPatronal,nombreCortoRazonSocial"
                options={this.state.empresasDisponibles} 
                onChange={(e) => this.seleccionDeLasEmpresas(e.value)} 
                itemTemplate={this.empresaTemplate}                                
                
                listStyle={{maxHeight: '250px'}}  
                multiple={true} />
              {errores.listaEmpresas ? (
                <Message severity="error" text={errores.listaEmpresas} />
              ) : null}              
            </div>
            <div className="p-col-2 p-lg-2">
              <strong>{this.state.empresasAsignadas.length}</strong> <span> empresa(s) asignada(s)</span>
            </div>
          </div>
        </Dialog>

        <Dialog
          header="Confirmación"
          visible={this.state.mostrarModalConfirmacion}
          modal={true}
          style={{ width: "30vw" }}
          footer={dialogFooterConfirmacionEliminar}
          onHide={() =>
            this.setState({
              usuario: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
        >
          <h2>¿Estás seguro de eliminar el usuario?</h2>
        </Dialog>

        <div className="p-col-12">
          <div className="card card-w-title">
            <DataTable value={paginacion.datos} responsive={true} resizableColumns={true} header="Mis usuarios">
              <Column field="usuario" header="Usuario" autoLayout={true} />
              <Column field="nombre" header="Nombre" autoLayout={true} />
              <Column field="apellidoPaterno" header="Apellido Paterno" autoLayout={true} />
              <Column field="apellidoMaterno" header="Apellido Materno" autoLayout={true} />
              <Column body={this.plantillaEstado} header="Estatus" autoLayout={true} />
              <Column field="correo" header="Correo" autoLayout={true} />
              <Column body={this.columnaFechaActualizacion} header="Fecha de Actualización" autoLayout={true} />
              <Column field="actualizacion" header="Actualización" autoLayout={true} />
              <Column header="Opciones" body={this.plantillaOpciones} autoLayout={true} />
            </DataTable>
          </div>
        </div>

        <Dialog header="Detalle cuenta de usuario" visible={mostrarModalDetalleUsuario} style={{ width: '50vw' }} modal={true} onHide={this.ocultarDetalleUsuario} footer={dialogFooterDetalleUsuario}>
          {servicioObjetos.esObjetoVacio(detalleUsuario) ? null :
            <div className="p-grid" style={{ fontSize: '16px', textAlign: 'center', padding: '20px' }}>
              <div className="p-col-4">Usuario: </div>
              <div className="p-col-8"><strong>{detalleUsuario.usuario}</strong></div>

              <div className="p-col-4">Nombre: </div>
              <div className="p-col-8"><strong>{detalleUsuario.nombre}</strong></div>

              <div className="p-col-4">Apellido Paterno: </div>
              <div className="p-col-8"><strong>{detalleUsuario.apellidoPaterno}</strong></div>

              <div className="p-col-4">Apellido Materno: </div>
              <div className="p-col-8"><strong>{detalleUsuario.apellidoMaterno}</strong></div>

              <div className="p-col-4">Correo: </div>
              <div className="p-col-8"><strong>{detalleUsuario.correo}</strong></div>

              <div className="p-col-4">Perfil: </div>
              <div className="p-col-8"><strong>{detalleUsuario.perfilToString}</strong></div>
            </div>
          }
        </Dialog>
      </div>
    );
  }
}
